import { useGoogleLogin } from "@react-oauth/google";
import { useTheme } from "../../../context/ThemeProvider";
import styles from "./CustomGoogleButton.module.css";
import { useAuth } from "../../../context/AuthProvider";

interface CustomGoogleButtonProps {
  onSuccess?: () => void;
  onError?: (text: string) => void;
}

const CustomGoogleButton: React.FC<CustomGoogleButtonProps> = ({
  onSuccess,
  onError,
}) => {
  const { getUserTheme } = useTheme();
  const { googleLogin } = useAuth();

  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async ({ code }) => {
      try {
        const isLogged = await googleLogin(code); // your backend call
        if (isLogged) getUserTheme();
        if (onSuccess) onSuccess();
      } catch (err) {
        if (err instanceof Error) {
          console.error("Login failed", err.message);
          if (onError) onError(err.message);
        } else {
          console.error("Login failed", err);
          if (onError) onError("Google login failed. Please try again.");
        }
      }
    },
    onError: (error) => {
      console.error("Google login error:", error);
      if (onError) onError("Google login failed.");
    },
  });

  return (
    <button onClick={() => login()} className={styles.button}>
      <img src="/images/logo/googleLogo.svg" alt="Google logo" />
      Sign in with Google
    </button>
  );
};

export default CustomGoogleButton;
